export enum SearchResultItemType {
  Athlete = "Athlete",
  NewsArticle = "NewsArticle",
  Event = "Event",
  General = "General",
}

export type Translations = {
  facets: {
    all: string;
    video: string;
    athletes: string;
    news: string;
    events: string;
    other: string;
  };
  ui: {
    placeholder: string;
    submit: string;
    loading: string;
    hits: string;
    noResults: string;
    hitsIn: string;
  };
};

export interface PageLink {
  url: string;
  title: string;
}

export interface ImageLink {
  url: string;
  altText?: string;
}

export interface VideoResultItem {
  videoId: string;
  heading: string;
  videoImageUrl: string;
  videoUrl: string;
  mainIntro: string;
  videoStartPageUrl: string;
}

export interface AthleteResultItem {
  club: PageLink;
  name: string;
  residentTown: string;
  shortDateOfBirth: string;
  team: string;
  jobTitle: string;
  phonenumber: string;
  email: string;
  profileImage: ImageLink;
  photoCredit?: string;
  fisAthleteId: number;
  fisAthleteSectorValue: string;
}

export interface NewsArticleResultItem {
  linkUrl: string;
  heading: string;
  mainIntro: string;
  date: string;
}

export interface EventResultItem {
  url: string;
  linkText: string;
  eventName: string;
  eventLocation: string;
}

export interface GeneralResultItem {
  url: string;
  linkText: string;
  intro: string;
}

export interface SearchResultItem {
  searchResultType: SearchResultItemType;
  athleteData?: AthleteResultItem;
  videoData?: VideoResultItem;
  newsArticleData?: NewsArticleResultItem;
  eventData?: EventResultItem;
  generalData?: GeneralResultItem;
}

export interface SearchResultModel {
  allPages: SearchResultItem[];
  allVideos: VideoResultItem[];
  allCount: number;
  noSearchResult: boolean;
  suggestion?: string;
}

export interface SearchModel {
  searchTerm: string;
  searchRootPageId: string;
  /** May be null */
  boostFrontPageId?: string;
}

export interface SearchPageViewModel {
  searchResultModel: SearchResultModel;
  initialSearchModel: SearchModel;
}
